module.exports = __webpack_public_path__ + "img/Port affairs handling_xuanzhong.ee91209f.png";